import { Injectable } from '@angular/core';
import { BaseService } from '@eview/core/base/base-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Media } from './media';
import { getFileNameFromMediaUrl } from './media-url.helpers';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '@eview/core/store/states/app.state';

@Injectable({
  providedIn: 'root'
})
export class MediaService extends BaseService {
  /** Bypasses interceptors — required for S3 presigned URLs (no Bearer). */
  private readonly rawHttp: HttpClient;

  readonly uris = {
    attach: 'media',
    read: 'media/:id'
  };

  constructor(http: HttpClient, store: Store<AppState>, httpBackend: HttpBackend) {
    super(http, store);
    this.rawHttp = new HttpClient(httpBackend);
  }

  attach(file: File): Observable<Media> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<Media>(this.getUrl(this.uris.attach), formData);
  }

  read(id: number): Observable<Media> {

    return this.http
      .get<Media>(this.getUrl(this.uris.read.replace(':id', id.toString())))
      .pipe(
        map(res => {
          if (res && res.original_file_url) {
            res.caption = getFileNameFromMediaUrl(res.original_file_url);
          }
          return res;
        })
      );
  }

  readContentAsBlob(url: string): Observable<Blob> {
    return this.rawHttp.get(url, {
      responseType: 'blob'
    });
  }
}
